// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import {buildNumber} from '../../../shared/services/build-number';

const statuses = {
    ONLY_LABEL: {
        className: '',
        label: 'DAYS_LEFT_WITH_COUNT'
    },
    PAST_DUE: {
        className: 'dot-icon-red',
        label: 'PAST_DUE'
    },
    WARNING: {
        className: 'dot-icon-yellow',
        label: 'DAYS_LEFT_WITH_COUNT'
    }
};

const getActiveStatus = days => {

    if (!days) {

        return 'PAST_DUE';

    } else if (days > 0 && days <= 30) {

        return 'WARNING';

    }

    return 'ONLY_LABEL';

};

const getStatus = days => {

    const activeStatus = getActiveStatus(days);

    return statuses[activeStatus];

};

const DaysRemaining = props => {

    const statusToDisplay = getStatus(props.daysRemaining);

    return (
        <div className='days-remaining'>
            <span className={statusToDisplay.className}/>
            <FormattedMessage
                id={statusToDisplay.label}
                values={{
                    days: props.daysRemaining,
                    daysToDisplay: buildNumber(props.daysRemaining)
                }}
            />
        </div>
    );

};

DaysRemaining.displayName = 'DaysRemaining';
DaysRemaining.propTypes = {
    daysRemaining: PropTypes.number.isRequired
};

export default DaysRemaining;



// WEBPACK FOOTER //
// ./src/tcsm/shared/components/days-remaining.js